import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdOutlineAssignmentTurnedIn } from "react-icons/md";

//utils
import { formatDate } from "../../../../../helpers";
import UsuarioContext from "../../../../../context/userContext/context";

//componentts
import { Container, Spinner} from "react-bootstrap"
import { CardAccountDetail } from "./components/card-account-detail";
import { CardAccessDetail } from "./components/card-access-detail";
import { CardCompanyDetail } from "./components/card-company-detail";
import { CardSignatureDetail } from "./components/card-signature-detail";

//services & models
import { IUserAccount } from "../../../../models/IUserAccount";
import { profileDetails } from "../../../../services/profile.service";

const DEFAULT_VALUE = {
  id: 0,
  name: "",
  company: "",
  job: "",
  phone: "",
  email: "",
  picture: "",
  signature: "",
  username: "",
  created_at: "",
  deleted_at: "",
  updated_at: "",
  is_superuser: false,
  is_staff: false,
  is_active: false,
  is_whatsapp: false,
  is_signature: false,
}

export const UserAccount = (): JSX.Element => {
  const { t: translation } = useTranslation();
  const { user: userContext, update } = useContext(UsuarioContext)

  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState<IUserAccount>(DEFAULT_VALUE);  

  useEffect(() => {
    getUser();
  }, [])

  const getUser = () => {
    profileDetails(userContext.id).then((response: any) => {
      setUser(response)
    }).finally(() => {
      setLoading(false);
    })
  }

  if (loading) {
    return (
      <div className="loading-container mt-5">
        <Spinner animation="border" variant="primary" />
      </div>
    )
  }

  return (
    <Container fluid>
      <h3 className="title-materials d-flex align-items-center">
        {translation('userAccount.account')}
        <span className="account-sign-title">
          <MdOutlineAssignmentTurnedIn /> {translation('userAccount.subscribe')} {formatDate(user.created_at)}
        </span>
      </h3>
      <hr />

      <Container>
        {/* Card Dados da conta */}
        <CardAccountDetail user={user} setUser={setUser} updateContext={update} userContext={userContext}></CardAccountDetail>

        {/* Card Acessos */}
        <CardAccessDetail user={user} updateContext={update} userContext={userContext}></CardAccessDetail>

        {/* Card Empresa */}
        <CardCompanyDetail company={user.company} user={user} getUser={getUser}></CardCompanyDetail>

        {/* Card Assinatura */}
        {
          user.is_signature &&
          <CardSignatureDetail></CardSignatureDetail>
        }
      </Container>
    </Container>
  )
}